import { useEffect, useState } from "react";
import { countHistoryLog, listHistoryLog } from "../api";

export const useListHistoryLog = (params) => {
    const [data, setData] = useState([]);
    async function fetchData() {
        const response = await listHistoryLog({ ...params });
        if (response.data.status) setData(response.data.data);
    };
    useEffect(() => { fetchData() }, [JSON.stringify(params)]);
    return data;
};

export const useCountHistoryLog = (params) => {
    const [data, setData] = useState(null);
    async function fetchData() {
        const response = await countHistoryLog({ ...params });
        if (response.data.status) setData(response.data.data);
    };
    useEffect(() => { fetchData() }, [JSON.stringify(params)]);
    return data;
};
